import { RootState } from '../../types';

export const getPopoverState = (state: RootState) => state.ui.popover.show;

export const getModalState = (state: RootState) => state.ui.modal;
